<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.29601,0.104441C8.93086,0.250873,8.58868,0.471982,8.29289,0.767767C7.93147,1.12919,7.68154,1.5599,7.54311,2.01714C4.44285,2.25057,2,4.84001,2,8C2,11.3137,4.68629,14,8,14C11.3137,14,14,11.3137,14,8C14,7.49818,13.9384,7.01075,13.8223,6.54485C13.8658,6.50617,13.9083,6.46608,13.9497,6.42462C13.9497,6.42462,15.4057,4.96865,15.4057,4.96865C15.7888,5.90357,16,6.92712,16,8C16,12.4183,12.4183,16,8,16C3.58172,16,0,12.4183,0,8C0,3.58172,3.58172,0,8,0C8.44126,0,8.87418,0.0357252,9.29601,0.104441C9.29601,0.104441,9.29601,0.104441,9.29601,0.104441ZM11.8284,5.3033C11.5725,5.3033,11.3166,5.20567,11.1213,5.01041C11.1213,5.01041,9.70711,3.59619,9.70711,3.59619C9.31658,3.20567,9.31658,2.5725,9.70711,2.18198C10.0976,1.79146,10.7308,1.79146,11.1213,2.18198C11.1213,2.18198,11.8284,2.88909,11.8284,2.88909C11.8284,2.88909,13.5962,1.12132,13.5962,1.12132C13.9867,0.730796,14.6199,0.730796,15.0104,1.12132C15.4009,1.51184,15.4009,2.14501,15.0104,2.53553C15.0104,2.53553,12.5355,5.01041,12.5355,5.01041C12.3403,5.20567,12.0843,5.3033,11.8284,5.3033C11.8284,5.3033,11.8284,5.3033,11.8284,5.3033ZM9,12C9,12,7,12,7,12C7,12,7,10,7,10C7,10,9,10,9,10C9,10,9,12,9,12C9,12,9,12,9,12ZM9,9C9,9,7,9,7,9C7,9,7,4,7,4C7,4,9,4,9,4C9,4,9,9,9,9C9,9,9,9,9,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IssueClosed',
} as DefineComponent
</script>
